/* =========================================================
   DEKOFAR PRODUCT SYSTEM V2
   SHIPPING PROMISE / ESTIMATED DELIVERY

   - Europe/Istanbul saatine göre çalışır.
   - HH:MM kapanış saatini doğrular.
   - Kapanıştan önce geri sayım gösterir.
   - Kapanıştan sonra "yarın kargoda" mesajı gösterir.
   - Tahmini teslimatta pazar günlerini saymaz.
   - Galerideki "Bugün Kargoda" rozetini saat dolunca gizler.
========================================================= */

(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-dekofar-v2-shipping-promise]';
  var PRODUCT_SELECTOR = '.dekofar-v2-product';
  var SAME_DAY_BADGE_SELECTOR = '[data-dekofar-v2-same-day-badge]';
  var UPDATE_INTERVAL = 30000;
  var initializedRoots = new WeakSet();

  function getIstanbulParts(date) {
    var formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Istanbul',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    var result = {};

    formatter.formatToParts(date || new Date()).forEach(function (part) {
      if (part.type !== 'literal') {
        result[part.type] = Number(part.value);
      }
    });

    return result;
  }

  function parseCutoff(value) {
    var match = String(value || '')
      .trim()
      .match(/^([01]\d|2[0-3]):([0-5]\d)$/);

    if (!match) {
      return null;
    }

    return {
      hour: Number(match[1]),
      minute: Number(match[2]),
      totalMinutes: (Number(match[1]) * 60) + Number(match[2])
    };
  }

  function isEnabled(root) {
    return root.getAttribute('data-same-day-enabled') === 'true';
  }

  function getShippingState(root) {
    var cutoff = parseCutoff(root.getAttribute('data-cutoff'));
    var now = getIstanbulParts(new Date());
    var currentMinutes = (now.hour * 60) + now.minute;

    if (!isEnabled(root) || !cutoff) {
      return {
        valid: false,
        beforeCutoff: false,
        remainingMinutes: 0
      };
    }

    return {
      valid: true,
      beforeCutoff: currentMinutes < cutoff.totalMinutes,
      remainingMinutes: Math.max(
        0,
        cutoff.totalMinutes - currentMinutes
      )
    };
  }

  function appendStrongMessage(
    container,
    prefix,
    strongText,
    suffix
  ) {
    if (!container) {
      return;
    }

    container.textContent = '';
    container.appendChild(document.createTextNode(prefix));

    var strong = document.createElement('strong');
    strong.textContent = strongText;
    container.appendChild(strong);

    if (suffix) {
      container.appendChild(document.createTextNode(suffix));
    }
  }

  function formatRemaining(minutes) {
    var hours = Math.floor(minutes / 60);
    var remainingMinutes = minutes % 60;

    if (hours > 0 && remainingMinutes > 0) {
      return hours + ' saat ' + remainingMinutes + ' dakika';
    }

    if (hours > 0) {
      return hours + ' saat';
    }

    return Math.max(1, remainingMinutes) + ' dakika';
  }

  function getProductScope(root) {
    return root.closest(PRODUCT_SELECTOR) || document;
  }

  function syncGalleryBadge(root, state) {
    var scope = getProductScope(root);
    var badges = scope.querySelectorAll(SAME_DAY_BADGE_SELECTOR);
    var mustHide = !state.valid || !state.beforeCutoff;

    scope.toggleAttribute(
      'data-dekofar-v2-cutoff-passed',
      mustHide
    );

    badges.forEach(function (badge) {
      if (mustHide) {
        badge.hidden = true;
        badge.setAttribute('aria-hidden', 'true');
        badge.setAttribute(
          'data-dekofar-v2-time-hidden',
          'true'
        );
      } else if (
        badge.getAttribute('data-dekofar-v2-time-hidden') === 'true'
      ) {
        badge.removeAttribute('data-dekofar-v2-time-hidden');
        badge.removeAttribute('aria-hidden');
      }
    });
  }

  function updateCountdown(root) {
    var countdown = root.querySelector(
      '[data-dekofar-v2-shipping-countdown]'
    );

    var text = root.querySelector(
      '[data-dekofar-v2-shipping-countdown-text]'
    );

    var state = getShippingState(root);

    if (!countdown || !text || !state.valid) {
      if (countdown) {
        countdown.hidden = true;
      }

      syncGalleryBadge(root, state);
      return;
    }

    countdown.hidden = false;

    if (state.beforeCutoff) {
      appendStrongMessage(
        text,
        formatRemaining(state.remainingMinutes) +
          ' içinde sipariş verirseniz ',
        'bugün kargoda!',
        ''
      );
    } else {
      appendStrongMessage(
        text,
        'Şimdi sipariş verin, ',
        'yarın kargoda!',
        ''
      );
    }

    syncGalleryBadge(root, state);
  }

  function addDeliveryDays(parts, numberOfDays) {
    var date = new Date(
      Date.UTC(
        parts.year,
        parts.month - 1,
        parts.day,
        12,
        0,
        0
      )
    );

    var added = 0;

    while (added < numberOfDays) {
      date.setUTCDate(date.getUTCDate() + 1);

      if (date.getUTCDay() !== 0) {
        added += 1;
      }
    }

    return date;
  }

  function formatTurkishDate(date) {
    var value = new Intl.DateTimeFormat('tr-TR', {
      timeZone: 'UTC',
      day: 'numeric',
      month: 'long',
      weekday: 'long'
    }).format(date);

    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  function updateEstimatedDelivery(root) {
    var target = root.querySelector(
      '[data-dekofar-v2-estimated-delivery-date]'
    );

    if (!target) {
      return;
    }

    var deliveryDays =
      Number(root.getAttribute('data-delivery-days')) || 3;

    deliveryDays = Math.max(
      1,
      Math.min(30, deliveryDays)
    );

    var today = getIstanbulParts(new Date());
    var deliveryDate = addDeliveryDays(
      today,
      deliveryDays
    );

    target.textContent = formatTurkishDate(deliveryDate);

    target.setAttribute(
      'datetime',
      deliveryDate.toISOString().slice(0, 10)
    );
  }

  function closeTooltip(root) {
    var button = root.querySelector(
      '[data-dekofar-v2-shipping-info-button]'
    );

    var tooltip = root.querySelector(
      '[data-dekofar-v2-shipping-tooltip]'
    );

    if (!button || !tooltip) {
      return;
    }

    tooltip.hidden = true;
    button.setAttribute('aria-expanded', 'false');
  }

  function setupTooltip(root) {
    var button = root.querySelector(
      '[data-dekofar-v2-shipping-info-button]'
    );

    var tooltip = root.querySelector(
      '[data-dekofar-v2-shipping-tooltip]'
    );

    if (!button || !tooltip) {
      return;
    }

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var willOpen = tooltip.hidden;

      document
        .querySelectorAll(ROOT_SELECTOR)
        .forEach(function (otherRoot) {
          if (otherRoot !== root) {
            closeTooltip(otherRoot);
          }
        });

      tooltip.hidden = !willOpen;

      button.setAttribute(
        'aria-expanded',
        willOpen ? 'true' : 'false'
      );
    });

    tooltip.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    document.addEventListener('click', function () {
      closeTooltip(root);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !tooltip.hidden) {
        closeTooltip(root);
        button.focus();
      }
    });
  }

  function setupCarriersModal(root) {
    var openButton = root.querySelector(
      '[data-dekofar-v2-carriers-open]'
    );

    var modal = root.querySelector(
      '[data-dekofar-v2-carriers-modal]'
    );

    var closeButtons = modal
      ? modal.querySelectorAll(
          '[data-dekofar-v2-carriers-close]'
        )
      : [];

    if (!openButton || !modal) {
      return;
    }

    function openModal() {
      modal.hidden = false;

      document.documentElement.classList.add(
        'dekofar-v2-carriers-open'
      );

      var closeButton = modal.querySelector(
        '.dekofar-v2-carriers-modal__close'
      );

      if (closeButton) {
        closeButton.focus();
      }
    }

    function closeModal() {
      modal.hidden = true;

      document.documentElement.classList.remove(
        'dekofar-v2-carriers-open'
      );

      openButton.focus();
    }

    openButton.addEventListener('click', openModal);

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeModal();
      }
    });
  }

  function setupVariantSync(root) {
    var scope = getProductScope(root);
    var scheduled = false;

    function scheduleSync() {
      if (scheduled) {
        return;
      }

      scheduled = true;

      window.requestAnimationFrame(function () {
        scheduled = false;
        updateCountdown(root);
      });
    }

    scope.addEventListener('change', scheduleSync);
    scope.addEventListener('click', scheduleSync);

    document.addEventListener(
      'dekofar:v2:variant-change',
      scheduleSync
    );

    document.addEventListener(
      'variant:change',
      scheduleSync
    );
  }

  function initializeRoot(root) {
    if (!root || initializedRoots.has(root)) {
      return;
    }

    initializedRoots.add(root);

    updateCountdown(root);
    updateEstimatedDelivery(root);
    setupTooltip(root);
    setupCarriersModal(root);
    setupVariantSync(root);

    var intervalId = window.setInterval(function () {
      if (!document.documentElement.contains(root)) {
        window.clearInterval(intervalId);
        return;
      }

      updateCountdown(root);
      updateEstimatedDelivery(root);
    }, UPDATE_INTERVAL);
  }

  function dekofarV2InitShippingPromises(scope) {
    var context = scope || document;

    if (
      context.matches &&
      context.matches(ROOT_SELECTOR)
    ) {
      initializeRoot(context);
    }

    context
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(initializeRoot);
  }

  window.dekofarV2InitShippingPromises =
    dekofarV2InitShippingPromises;

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        dekofarV2InitShippingPromises(document);
      },
      { once: true }
    );
  } else {
    dekofarV2InitShippingPromises(document);
  }
})();